"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShowOfflineButton = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var FlatButton_1 = __importDefault(require("@atg/icf-react-components/components/FlatButton"));
var Flex_1 = __importDefault(require("@atg/icf-react-components/components/Flex"));
var react_jss_1 = require("react-jss");
var useShowOfflineButtonStyles = (0, react_jss_1.createUseStyles)(function (theme) { return ({
    buttonContainer: {
        width: "100%",
        display: "flex",
        flexDirection: "row",
        justifyContent: "end",
        margin: "".concat(theme.spacing.base * 3, "px 0"),
    },
}); });
var ShowOfflineButton = function (_a) {
    var onClick = _a.onClick, translate = _a.translate, breakpoint = _a.breakpoint;
    var classes = useShowOfflineButtonStyles();
    var isMobile = breakpoint === "small";
    if (isMobile) {
        return ((0, jsx_runtime_1.jsx)(Flex_1.default, { padding: "0 8 8", marginBottom: 10, children: (0, jsx_runtime_1.jsx)(FlatButton_1.default, { "data-ta-locator": "showOfflineButton", label: translate("search.show_offline_button"), fullWidth: isMobile, ghost: true, size: "small", onClick: onClick }) }));
    }
    else {
        return ((0, jsx_runtime_1.jsx)("div", { className: classes.buttonContainer, "data-ta-locator": "offline-button", children: (0, jsx_runtime_1.jsx)(FlatButton_1.default, { ghost: true, fullWidth: isMobile, "data-ta-locator": "showOfflineButton", iconRight: "arrowForward", label: translate("search.show_offline_button"), onClick: onClick }) }));
    }
};
exports.ShowOfflineButton = ShowOfflineButton;
exports.ShowOfflineButton.displayName = "ShowOfflineButton";
//# sourceMappingURL=ShowOfflineButton.js.map